import { Box, Flex, List, ListItem, ListItemText, Text } from '@shared/components';

export interface ImportExamineeErrorCardProps {
  title: string;
  errors: string[];
}

export default function ImportExamineeErrorCard(props: Readonly<ImportExamineeErrorCardProps>) {
  const { title, errors } = props;

  return (
    <Box
      sx={(theme) => ({
        bgcolor: theme.palette.error.lighter,
        borderRadius: theme.shape.rounded(2),
        p: theme.spacing(4),
      })}
    >
      <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(1) })}>
        <Text variant='body2Semibold'>{title}</Text>
        {errors.length ? (
          <List sx={(theme) => ({ listStyle: 'disc', p: theme.spacing(0, 0, 0, 10) })}>
            {errors.map((error, index) => (
              <ListItem
                key={`${error}-${index}`}
                sx={(theme) => ({
                  display: 'list-item',
                  p: 0,
                  ...theme.typography.body2,
                })}
              >
                <ListItemText
                  primary={error}
                  sx={{ m: 0 }}
                  slotProps={{
                    primary: {
                      variant: 'body2',
                    },
                  }}
                />
              </ListItem>
            ))}
          </List>
        ) : null}
      </Flex>
    </Box>
  );
}
